import * as React from 'react'
import { Box, IconButton } from '@mui/material'
import { AddBoxSharp, IndeterminateCheckBox } from '@mui/icons-material'
import { useTheme } from '@mui/material/styles'

const FilterButton = ({ add = false, onClick, pl }) => {
  const theme = useTheme()

  const COLOR_POPUP = theme.palette.primary.main
  const COLOR_RED = theme.palette.status.noProcess
  const COLOR_BOTTON = theme.palette.background.default
  const COLOR_BORDER = '#e3e7ea'

  const BTStyle = add => ({
    p: 0,
    width: '30px',
    height: '30px',
    color: COLOR_BOTTON,
    borderRadius: 'inherit',
    backgroundColor: COLOR_POPUP,
    border: `1px solid ${COLOR_BORDER}`,
    '&:hover': {
      backgroundColor: COLOR_BOTTON,
      color: add ? COLOR_POPUP : COLOR_RED,
      opacity: add ? 0.9 : 0.7,
    },
    '&:active': {
      backgroundColor: COLOR_BOTTON,
      color: add ? COLOR_POPUP : COLOR_RED,
      opacity: 0.9,
    },
  })

  return (
    <Box sx={{ pl, alignSelf: 'center' }}>
      <IconButton
        onClick={onClick}
        aria-label={add ? 'addnewfilter' : 'removefilter'}
        size="small"
        sx={BTStyle(add)}>
        {add ? (
          <AddBoxSharp fontSize="large" />
        ) : (
          <IndeterminateCheckBox fontSize="large" />
        )}
      </IconButton>
    </Box>
  )
}

export default FilterButton
